function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "42",
  height: "57",
  viewBox: "0 0 42 57",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M21.001 0C9.823 0 0 9.254 0 20.84c0 11.474 9.152 18.67 12.243 21.547 4.74 4.412 7.69 10.103 8.201 14.007.067.5.303.606.556.606.254 0 .49-.106.555-.606.512-3.904 3.461-9.595 8.202-14.007C32.849 39.51 42 32.314 42 20.84 42 9.254 32.18 0 21.001 0M21 26.49c-3.114 0-5.639-2.536-5.639-5.665 0-3.13 2.525-5.667 5.639-5.667 3.114 0 5.64 2.537 5.64 5.667 0 3.129-2.526 5.666-5.64 5.666",
  fill: "currentColor",
  fillRule: "evenodd"
})));